
import { defineComponent } from 'vue';
import ESARSite from '@/models/ESARSite';

export default defineComponent({
    name: 'ContaminationDetails',
    components: {},
    props: {
        siteDetails: ESARSite
    },
    setup() {
        const data = [
            { title: 'Hydrocarbon', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Benzene ', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Toluene', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Ethylbenzene', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Xylenes', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F1 (F1)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F2 (F2)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F3 (F3)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Petroleum hydrocarbon F4 (F4)', values: ['yes', 'no', 'yes', 'unknown'], },
            { title: 'Lead (Pb)', values: ['yes', 'no', 'yes', 'unknown'], },
        ];

        return { data };
    }
});
